import React from 'react';
import styled from '@emotion/styled';

const StyledCardImage = styled.img`
  height: auto;
  width: 100%;
`;

type CardImageProps = {
  src?: string;
  alt: string;
};

const CardImage = ({ src = '/images/car-image-not-found.svg', alt }: CardImageProps) => (
  <StyledCardImage {...{ src, alt }} />
);

export default CardImage;
